import { FulfilmentPresentation } from './types';

export const CARRIER_NAMES = {
  teamGlobalExpress: 'Team Global Express',
  ausPost: 'Australia Post',
  uber: 'Uber',
};

export const EXPERIENCE_NAMES = {
  asap: 'ASAP',
  scheduled: 'Scheduled',
  standard: 'Standard',
  express: 'Express',
};

export enum OptionNames {
  Delivery = 'Delivery',
  ClickAndCollect = 'ClickAndCollect',
  CashAndCarry = 'CashAndCarry',
}

export const FULFILMENT_REQUEST_OPTIONS_IN_STORE = [OptionNames.ClickAndCollect, OptionNames.CashAndCarry];
export const FULFILMENT_REQUEST_OPTIONS_DELIVERY = [OptionNames.Delivery];

export const sortDeliveryPresentations = (
  deliveryPres: Array<FulfilmentPresentation>
): Array<FulfilmentPresentation> => {
  const cheapest: Array<FulfilmentPresentation> = [];
  const fastest: Array<FulfilmentPresentation> = [];
  const rest: Array<FulfilmentPresentation> = [];

  deliveryPres?.forEach(element => {
    if (element.tags?.includes('Cheapest')) {
      cheapest.push(element);
    } else if (element.tags?.includes('Fastest')) {
      fastest.push(element);
    } else {
      rest.push(element);
    }
  });

  // sort the delivery options other than Cheapest and Fastest based on price
  rest.sort((a: FulfilmentPresentation, b: FulfilmentPresentation) => {
    return a.price - b.price;
  });

  const sortedDeliveryPresentations = [...cheapest, ...fastest, ...rest];
  const containsAsapDeliveryOption = sortedDeliveryPresentations.some(
    s => s.carrier?.name === CARRIER_NAMES.uber && s.experienceName === EXPERIENCE_NAMES.asap
  );

  return containsAsapDeliveryOption
    ? sortedDeliveryPresentations.filter(s => s.experienceName !== EXPERIENCE_NAMES.scheduled)
    : sortedDeliveryPresentations;
};
